// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2YnLO","list":"PatternAutocomplete_list__1MKuw"};